const CheckAll = ({
  checked,
  onChange,
  className = "absolute left-4 top-26 mt-3",
}: {
  checked: boolean;
  onChange: () => any;
  className?: string;
}) => {
  return (
    <div className={className}>
      <div className="flex items-center py-2 ">
        <input
          className="cursor-pointer"
          checked={checked}
          type="checkbox"
          onChange={onChange}
          id="check-all"
          aria-label="Select all"
          data-testid="check-all"
        ></input>
      </div>
    </div>
  );
};

export default CheckAll;
